<section>
  <h1 class="page-title" [cypress]="'page_title'">{{ "COMPANY_DATA.TITLE" | translate }}</h1>
</section>
<section class="company-data-content">
  <p class="page-intro-text">{{ "COMPANY_DATA.INTRO_TEXT" | translate }}</p>
  <form [formGroup]="formGroup" (ngSubmit)="formSubmit()">
    <section>
      <bca-company-search
        [selectedCompany]="selectedCompany$ | async"
        [companyFetching]="companyFetching$ | async"
        [companyLoading]="companyLoading$ | async"
        [companyRequiredError]="getCompanyErrorKey()"
        [searchFn]="companySearchFn"
        (close)="onCompanyClosed()"
        (focus)="onCompanyFocus()"
        (focusout)="onCompanyFocusOut()"
        (selected)="onCompanySelected($event)"
      >
      </bca-company-search>
    </section>

    <ng-container *ngIf="selectedCompany$ | async as selectedCompany">
      <section id="bca_company_employees_container" class="mb-4">
        <bca-company-employees
          [employeeRequiredError]="getEmployeeAmountErrorKey()"
          [employeeAmount]="(selectedCompany$ | async).employeeAmount"
          (selected)="onEmployeeAmountSelected($event)"
        >
        </bca-company-employees>
      </section>
    </ng-container>

    <section class="mb-3 animated fadeIn representative-section">
      <h2 class="representative-title">{{ "COMPANY_DATA.REPRESENTATIVE_TITLE" | translate }}</h2>
      <p class="section-body-text">{{ "COMPANY_DATA.REPRESENTATIVE_DESCRIPTION" | translate }}</p>

        <bca-user-form
          [cypress]="'representative'"
          [userForm]="getControl('representative')"
          [middleNames]="middleNames$ | async"
          [checkedSignatoryStatus]="signatoryStatus$ | async"
          [hasEmailTooltip]="true"
          (sendError)="handleUserFormError($event)"
          (resetStatus)="resetSignatoryStatus()"
        >
        </bca-user-form>
    </section>

    <section>
        <h2 class="contactperson-title">{{ "COMPANY_DATA.CONTACTPERSON_TITLE" | translate }}</h2>
        <p class="section-body-text">{{ "COMPANY_DATA.CONTACTPERSON_DESCRIPTION" | translate }}</p>
        <div class="formfield">
          <div
            [cypress]="'check_contactPerson'"
            class="checkbox formfield__checkbox"
          >
            <div class="nes-flex nes-items-center">
              <input
                type="checkbox"
                class="nes-h-6 nes-w-6" style="margin-right: 16px"
                id="diffContactPersonChecked"
                [checked]="differentContactPersonChecked$ | async"
                (change)="onDifferentContactPersonChecked($event.target.checked)"
              />
              <label class="checkbox__label checkbox-label-styled nes-pl-0" for="diffContactPersonChecked" tabindex="-1">
                {{ "COMPANY_DATA.INPUT.CONTACT_PERSON.CHECKBOX_LABEL" | translate }}
              </label>
            </div>
          </div>
        </div>

        <ng-container *ngIf="differentContactPersonChecked$ | async">
          <section class="mb-3 animated fadeIn">
            <section class="mt-3" id="scroll_contactPerson">
              <bca-user-form
                [cypress]="'contactPerson'"
                [userForm]="getControl('contactPerson')"
                [middleNames]="middleNames$ | async"
                (sendError)="handleUserFormError($event)"
              >
              </bca-user-form>
            </section>
          </section>
        </ng-container>
      </section>

    <hr class="form-separator">
    <div class="actionBar">
      <div class="actionBar__container actionBar__container--left">
        <nes-button
          icon-trailing="true"
          [cypress]="'next_page'"
          type="submit"
          nes-id="to_verify_page"
          id="to_verify_page"
          variant="brand"
          (nesOnClick)="formSubmit()"
        >
          {{ "COMPANY_DATA.BUTTON.COMPLETE_ORDER" | translate }}
        </nes-button>
      </div>
    </div>
  </form>

  <ng-container *ngIf="(cartProducts$ | async)?.length > 0">
    <div class="mobile-cart lg:nes-hidden nes-mt-4">
      <aside class="order-cart">
        <h3 class="cart-title">
            <span class="cart-title__line1">{{ 'VERIFY.CART.TITLE' | translate }}</span>
            <span class="cart-title__line2">{{ totalProductCount$ | async }} NS-Business Card{{ (totalProductCount$ | async) > 1 ? 's' : '' }}</span>
        </h3>

        <ng-container *ngFor="let product of cartProducts$ | async">
          <div class="cart-product-box">
            <div class="cart-row cart-row--name" *ngIf="product.user">
              <span>{{ product.user | displayName | async }}</span>
            </div>
            <div class="cart-row">
              <span>{{ 'COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS.' + product.identifier + '.TITLE' | translate }}</span>
              <span>€ {{ product.price | priceFormat }}</span>
            </div>
            <ng-container *ngFor="let addon of product.addons">
              <div *ngIf="addon.identifier === 'BFA' && addon.selected" class="cart-row">
                <span>{{ 'VERIFY.IC_DIRECT_TITLE' | translate }}</span>
                <span>€ {{ addon.price | priceFormat }}</span>
              </div>
              <div *ngIf="addon.identifier.includes('_UPDATE') && addon.selected" class="cart-row">
                <span>{{ 'VERIFY.ADDON.' + addon.identifier + '.TITLE' | translate }}</span>
                <span *ngIf="addon.price">€ {{ addon.price | priceFormat }}</span>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <div class="cart-subtotals">
          <div class="cart-row">
            <span>{{ 'VERIFY.SUBTOTAL' | translate }}</span>
            <span>€ {{ cartSubTotalReceiptPrice$ | async | priceFormat }}</span>
          </div>
          <div class="cart-row">
            <span>{{ 'VERIFY.TAX_PRICE' | translate }}</span>
            <span>€ {{ cartTax$ | async | priceFormat }}</span>
          </div>
        </div>

        <hr class="cart-separator" />

        <div class="cart-total-row">
          <span>{{ 'FREQUENTION.MONTH_TOTAL' | translate }}</span>
          <span>€ {{ cartTotalReceiptPrice$ | async | priceFormat }}</span>
        </div>

        <nes-button
          [cypress]="'next_page_mobile'"
          variant="secondary"
          (nesOnClick)="goToBesteloverzicht()"
        >
          {{ 'VERIFY.BUTTON.EDIT_ORDER' | translate }}
        </nes-button>
      </aside>
    </div>
  </ng-container>
</section>
